export const getTicketCode = (ticket) => {
	if (!ticket) return "N/A";
	return `${ticket.prefix.toUpperCase()}${ticket.number
		.toString()
		.substr(-3)}`;
};
